import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../../Globals/constants';
import { DragSource } from 'react-dnd';
import Radium from 'radium';
import { } from '../../../Globals/styles';

class EmployeeDragable extends Component{
  componentWillMount = () => {
    this.props.connectDragPreview(null, {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  };
  render()  {
    const { connectDragSource } = this.props;

    return connectDragSource(
          <div style={styles.dragable}>
            <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
          </div>
        );
  }
}

var styles = {
  dragable: {
    position: 'absolute',
    left: '0',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px'
  }

}

const EmployeeSource = {
  beginDrag(props) {
    props.setEmployeeIsDragging(props.employee.id)
    return {
      employeeIndex: props.index,
      hours: props.hours,
      employeeId: props.employeeId,
      isNight: props.isNight,
      employeeName: props.employee.name,
      isActive: props.isActive,
      isAbsent: props.isAbsent,
      getButtonContent: props.getButtonContent,
      isOpen: props.isOpen
    };
  },
  endDrag(props){
    props.setEmployeeIsDragging(null)
  }
};
function collect(connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
    //isDragging: monitor.isDragging()
  }
}
  EmployeeDragable.propTypes = {
    employee: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
      nightHours: PropTypes.number,
      activities: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        hours: PropTypes.number
      })).isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string
      })
    }).isRequired,
    index: PropTypes.number.isRequired,
    isNight: PropTypes.bool.isRequired,
    hours: PropTypes.number.isRequired,
    setEmployeeIsDragging: PropTypes.func.isRequired,
    getButtonContent: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired
  };
export default DragSource(dragNDropConstants.EMPLOYEE, EmployeeSource, collect)(Radium(EmployeeDragable));


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/Sidebar/employeeDragable.jsx